<!-- ফিল্টার বার — নেভবারের নিচে আনুভূমিকভাবে (চাইল্ড ক্যাটাগরিতে গেলে দেখায়) -->
<div class="filter-bar">

  <span class="filter-title">{{ bn() ? 'ফিল্টার' : 'Filters' }}</span>

  <!-- BRAND -->
  <div class="filter-item" *ngIf="facets.brands.length > 0">
    <button
      type="button"
      class="filter-btn"
      [class.active]="selected.brands.length > 0 || sectionsOpen['brand']"
      (click)="toggleSection('brand')">
      <span>{{ bn() ? 'ব্র্যান্ড' : 'Brand' }}</span>
      <span class="badge" *ngIf="selected.brands.length > 0">{{ selected.brands.length | bnNumber }}</span>
      <span class="chevron" [class.open]="sectionsOpen['brand']">▾</span>
    </button>

    <div class="dropdown" *ngIf="sectionsOpen['brand']">
      <input
        *ngIf="facets.brands.length > 6"
        type="text"
        class="mini-search"
        [(ngModel)]="brandSearch"
        [placeholder]="bn() ? 'ব্র্যান্ড খুঁজুন' : 'Search brand'"
      />

      <div class="option-list">
        <label class="option-row" *ngFor="let b of filteredBrandList">
          <input
            type="checkbox"
            [checked]="isBrandSelected(b.brand)"
            (change)="toggleBrand(b.brand)"
          />
          <span class="option-label">{{ b.brand }}</span>
          <span class="option-count">({{ b.count | bnNumber }})</span>
        </label>
      </div>
    </div>
  </div>

  <!-- PRICE -->
  <div class="filter-item" *ngIf="facets.minPrice !== null">
    <button
      type="button"
      class="filter-btn"
      [class.active]="selected.minPrice !== null || selected.maxPrice !== null || sectionsOpen['price']"
      (click)="toggleSection('price')">
      <span>{{ bn() ? 'দাম' : 'Price' }}</span>
      <span class="chevron" [class.open]="sectionsOpen['price']">▾</span>
    </button>

    <div class="dropdown" *ngIf="sectionsOpen['price']">
      <div class="price-row">
        <input
          type="number"
          class="price-input"
          [(ngModel)]="selected.minPrice"
          (change)="onPriceChange()"
          [placeholder]="'৳' + facets.minPrice"
        />
        <span class="price-sep">–</span>
        <input
          type="number"
          class="price-input"
          [(ngModel)]="selected.maxPrice"
          (change)="onPriceChange()"
          [placeholder]="'৳' + facets.maxPrice"
        />
      </div>
    </div>
  </div>

  <!-- WEIGHT / PACK SIZE -->
  <div class="filter-item" *ngIf="facets.weights.length > 0">
    <button
      type="button"
      class="filter-btn"
      [class.active]="selected.weights.length > 0 || sectionsOpen['weight']"
      (click)="toggleSection('weight')">
      <span>{{ bn() ? 'ওজন / সাইজ' : 'Weight' }}</span>
      <span class="badge" *ngIf="selected.weights.length > 0">{{ selected.weights.length | bnNumber }}</span>
      <span class="chevron" [class.open]="sectionsOpen['weight']">▾</span>
    </button>

    <div class="dropdown" *ngIf="sectionsOpen['weight']">
      <div class="option-list">
        <label class="option-row" *ngFor="let w of facets.weights">
          <input
            type="checkbox"
            [checked]="isWeightSelected(w.weight)"
            (change)="toggleWeight(w.weight)"
          />
          <span class="option-label">{{ w.weight }}</span>
          <span class="option-count">({{ w.count | bnNumber }})</span>
        </label>
      </div>
    </div>
  </div>

  <!-- AVAILABILITY — সরাসরি টগল বাটন -->
  <button
    type="button"
    class="filter-btn"
    [class.active]="selected.inStock"
    (click)="toggleInStock()">
    <span>{{ bn() ? 'শুধু স্টকে আছে' : 'In stock only' }}</span>
  </button>

  <button
    type="button"
    *ngIf="hasActiveFilters()"
    class="clear-btn"
    (click)="resetSelection()">
    {{ bn() ? 'সব মুছুন' : 'Clear all' }}
  </button>

</div>
